import React from 'react';
import { H4 } from '../../AbstractElements';

export const AreaColumns = [
    {
        name: <H4>Area</H4>,
        selector: row => row.Area,
        sortable: true,
        width:'400px',
        sortFunction: (a, b) => {
            const nameA = a?.Area?.toString().toLowerCase() || '';
            const nameB = b?.Area?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Area Code</H4>,
        selector: row => row.AreaCode,
        sortable: true,
        width:'250px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        width:'200px',
        center: true,
    },
];

export const ProviderColumns = [
    {
        name: <H4>Name</H4>,
        selector: row => row.Name,
        sortable: true,
        width:'210px',
        wrap:true,
        sortFunction: (a, b) => {
            const nameA = a?.Name?.toString().toLowerCase() || '';
            const nameB = b?.Name?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Description</H4>,
        selector: row => row.Description,
        sortable: true,
        // center: true,
        width:'160px',
        wrap:true,
        sortFunction: (a, b) => {
            const nameA = a?.Description?.toString().toLowerCase() || '';
            const nameB = b?.Description?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        sortable: true,
        center: true,
        width:'280px',
    },
];

export const HeaderColumns = [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        sortable: true,
        center: false,
        width:'180px',
    },
    {
        name: <H4>Title</H4>,
        selector: row => row.Title,
        sortable: true,
        // center: true,
        width:'210px',
        wrap:true,
        
    },
    {
        name: <H4>Description</H4>,
        selector: row => row.Description,
        sortable: true,
        // center: true,
        width:'160px',
        wrap:true,
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        sortable: true,
        center: true,
        width:'280px',
    },
];
export const VendorColumns = [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Si,
        sortable: true,
        center: false,
        width:'130px',
    },
    {
        name: <H4>Title</H4>,
        selector: row => row.title,
        sortable: true,
        // center: true,
        width:'170px',
        wrap:true,
        
    },
    {
        name: <H4>Mobile</H4>,
        selector: row => row.mobile,
        sortable: true,
        // center: true,
        width:'190px',
        wrap:true,
        
    },
    {
        name: <H4>Email</H4>,
        selector: row => row.email,
        sortable: true,
        // center: true,
        width:'210px',
        wrap:true,
        
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        sortable: true,
        center: true,
        width:'280px',
    },
];

export const PaymentColumns = [
    {
        name: <H4>Name</H4>,
        selector: row => row.Name,
        sortable: true,
        width:'250px',   
        sortFunction: (a, b) => {
            const nameA = a?.Name?.toString().toLowerCase() || '';
            const nameB = b?.Name?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Code</H4>,
        selector: row => row.Code,
        sortable: true,
        width:'190px',
        sortFunction: (a, b) => {
            const nameA = a?.Code?.toString().toLowerCase() || '';
            const nameB = b?.Code?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Order</H4>,
        selector: row => row.Order,
        sortable: true,
        width:'150px',
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        center: true,
    },
];

export const CategoryColumns = [
    {
        name: <H4>Name</H4>,
        selector: row => row.Name,
        sortable: true,
        width:'280px',
        sortFunction: (a, b) => {
            const nameA = a?.Name?.toString().toLowerCase() || '';
            const nameB = b?.Name?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Type</H4>,
        selector: row => row.Type,
        sortable: true,
        width:'200px',
        sortFunction: (a, b) => {
            const nameA = a?.Type?.toString().toLowerCase() || '';
            const nameB = b?.Type?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        width:'100px',
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        center: true,
    },
];

export const TaxGroupColumns = [
    {
        name: <H4>Sl</H4>,
        selector: row => row.Sl,
        sortable: true,
        center: false,
    },
    {
        name: <H4>Title</H4>,
        selector: row => row.Name,
        sortable: true,
        // center: true,
    },
    {
        name: <H4>Tax</H4>,
        selector: row => row.Tax,
        sortable: true,
        // center: true,
    },
    {
        name: <H4>Description</H4>,
        selector: row => row.Description,
        sortable: true,
        // center: true,
    },
    {
        name: <H4>Total %</H4>,
        selector: row => row.Total,
        sortable: true,
        // center: true,
    },
   
    {
        name: <H4>Status</H4>,
        selector: row => row.Status,
        sortable: true,
        center: true,
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        cell: row => <ActionCell row={row} />,
        sortable: true,
        center: true,
    },
];

export const CouponColumns = [
    {
        name: <H4>Coupon Name</H4>,
        selector: row => row.Area,
        sortable: true,
        width:'200px',
        sortFunction: (a, b) => {
            const nameA = a?.Area?.toString().toLowerCase() || '';
            const nameB = b?.Area?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Code</H4>,
        selector: row => row.Code,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Type</H4>,
        selector: row => row.Type,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Discount</H4>,
        selector: row => row.Discount,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Amount</H4>,
        selector: row => row.Amount,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Shipping Free</H4>,
        selector: row => row.Shipping,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Customer Login</H4>,
        selector: row => row.Login,
        sortable: true,
        width:'100px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Start Date</H4>,
        selector: row => row.StartDate,
        sortable: true,
        width:'150px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>End Date</H4>,
        selector: row => row.EndDate,
        sortable: true,
        width:'150px',
        sortFunction: (a, b) => {
            const nameA = a?.AreaCode?.toString().toLowerCase() || '';
            const nameB = b?.AreaCode?.toString().toLowerCase() || '';
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        }
    },
    {
        name: <H4>Action</H4>,
        selector: row => row.action,
        width:'200px',
        center: true,
    },
];